import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Confirm, NotifyCircle, Alert } from '@sumup/icons';
import isPropValid from '@emotion/is-prop-valid';
import styled from '../../styles/styled';
import { typography } from '../../styles/style-mixins';
const baseStyles = ({ theme }) => css `
  display: block;
  margin-top: ${theme.spacings.bit};
  color: ${theme.colors.n700};
  transition: color ${theme.transitions.default};
`;
const validStyles = ({ theme, showValid }) => showValid &&
    css `
    color: ${theme.colors.confirm};
  `;
const warningStyles = ({ theme, hasWarning, }) => hasWarning &&
    css `
    color: ${theme.colors.n900};
  `;
const invalidStyles = ({ theme, invalid }) => invalid &&
    css `
    color: ${theme.colors.alert};
  `;
const Wrapper = styled('span')(typography('two'), baseStyles, validStyles, invalidStyles, warningStyles);
const IconWrapper = styled('div', {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'color',
})(({ theme, color }) => css `
      display: inline-block;
      position: relative;
      width: ${theme.iconSizes.kilo};
      height: ${theme.iconSizes.kilo};
      vertical-align: text-top;
      margin-right: ${theme.spacings.bit};
      color: ${theme.colors[color]};
    `, ({ theme, color }) => color === 'notify' &&
    css `
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 2px;
        left: 2px;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        background: ${theme.colors.black};
        border-radius: ${theme.borderRadius.circle};
      }
      svg {
        position: relative;
        z-index: 1;
      }
    `);
const getIcon = (state) => {
    switch (true) {
        case state.disabled: {
            return null;
        }
        case state.invalid: {
            return (_jsx(IconWrapper, { color: "alert", children: _jsx(Alert, { role: "presentation", size: "16" }, void 0) }, void 0));
        }
        case state.hasWarning: {
            return (_jsx(IconWrapper, { color: "notify", children: _jsx(NotifyCircle, { role: "presentation", size: "16" }, void 0) }, void 0));
        }
        case state.showValid: {
            return (_jsx(IconWrapper, { color: "confirm", children: _jsx(Confirm, { role: "presentation", size: "16" }, void 0) }, void 0));
        }
        default: {
            return null;
        }
    }
};
/**
 * @private
 */
export const ValidationHint = ({ validationHint, ...props }) => {
    if (!validationHint) {
        return null;
    }
    const icon = getIcon(props);
    return (_jsxs(Wrapper, { invalid: props.invalid, showValid: props.showValid, hasWarning: props.hasWarning, children: [icon, validationHint] }, void 0));
};
